import { render, staticRenderFns } from "./HealthCategoryDialog.vue?vue&type=template&id=06843756&scoped=true"
import script from "./HealthCategoryDialog.vue?vue&type=script&lang=js"
export * from "./HealthCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./HealthCategoryDialog.vue?vue&type=style&index=0&id=06843756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06843756",
  null
  
)

export default component.exports